export enum JuridicalKind {
  Person,
  Company,
}

export enum IDKind {
  Passport,
  SwedishPersonalID,
  SwedishOrgNumber,
  ForeignCompanyDirector,
  ForeignManual,
  Fictitious,
}
